module.exports = __webpack_public_path__ + "media/customizations/samlarc/back-c5dbd61a61a5a24b79196102559dd872.jpg";